export default "__VITE_ASSET__B7Wb6tq8__"